export default "__VITE_ASSET__1C3U99UM__"